export default __webpack_public_path__ + "static/media/expl-dissect_08_EN.d334be36.png";